module.exports = __webpack_public_path__ + "assets/img/00129.4ce28dc7.png";